import { Error } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import {
  CountdownTimer,
  EventInfoFragment,
  FormTextField,
  RaceOrRacepackInfo,
  RacepacksFragments,
  TicketSummaryDialog,
} from '..';
import api from '../../services/apiClient';
import { useGetVirtualInformationQuery } from '../../services/iracedb';
import { toCurrencyForm } from '../../utils/stringFormatter';
import CustomTabPanel, { a11lyProps } from '../CustomTabPanel/CustomTabPanel';
import classes from './style';
import DetailVirtualParticipants from './DetailVirtualParticipants';
import VirtualTicketSummary from './VirtualTicketSummary';

const VirtualEventInformation = ({ id }) => {
  // console.log('in virtual event information ', id);
  const { data, isFetching, error } = useGetVirtualInformationQuery(id);

  // console.log(data);

  const isMobile = useMediaQuery('(max-width:600px)');
  const isTab = useMediaQuery('(max-width:1000px)');

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isOpenSummary, setIsOpenSummary] = useState(false);

  const [tabIdx, setTabIdx] = useState(0);
  const [dp, setDp] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [loadOrderAndGetSnapToken, setLoadOrderAndGetSnapToken] =
    useState(false);
  const [isFetchingCodeStatus, setIsFetchingCodeStatus] = useState(false);
  const [snapToken, setSnapToken] = useState('');
  const [chartUrl, setChartUrl] = useState();
  const [code, setCode] = useState({ value: '', errorMessage: '', data });
  //#endregion

  //#region useeffect
  useEffect(() => {
    if (snapToken === '') return;

    window.location.href = snapToken;
  }, [snapToken]);

  //   useEffect(() => {
  //     getSizeChartUrl();
  //   }, [data?.racepacks]);
  //#endregion

  //#region function
  //   const getSizeChartUrl = () => {
  //     if (!data?.racepacks.length === 0) return;

  //     const sizeChart = data?.racepacks?.find((rcp) =>
  //       rcp.name.includes('Chart')
  //     );

  //     setChartUrl(sizeChart?.image);
  //   };

  // const isSizeLimitValid = async () => {
  // if (data?.sizesInfo?.length === 0)
  //   return { valid: true, alertMessage: 'ok' };

  // const data = [...participants];

  // const sizes = [];

  // for (let index = 0; index < data.length; index++) {
  //   const element = data[index];

  //   const isFoundIdx = sizes.findIndex(
  //     (s) => s?.size === element?.size?.value
  //   );

  //   // console.log('is size limit valid, isFound ', isFoundIdx);

  //   if (isFoundIdx < 0) {
  //     sizes.push({ size: element.size.value, sizeCount: 1 });
  //   } else {
  //     sizes[isFoundIdx].sizeCount++;
  //   }
  // }
  // // console.log('is size limit valid ', sizes);
  // try {
  //   setCheckLimitLoad(true);
  //   const { data } = await api.post('/events/size/limit', {
  //     eventId,
  //     sizes,
  //   });

  //   setCheckLimitLoad(false);
  //   // console.log(result);
  //   if (data.isValid === false)
  //     return { valid: false, alertMessage: data.message };

  //   return { valid: true, alertMessage: 'ok' };
  // } catch (error) {
  //   setCheckLimitLoad(false);
  //   return { valid: false, alertMessage: error.message };
  // }
  // };

  const register = async ({ bill, coupon, selectedAddons, shippingFee }) => {
    // console.log('register virtual event free!');

    // if (data?.info?.eventId === 45 && !coupon?.data?.coupon_id)
    //   return alert('You can continue after use coupon');

    const params = { ...dp };
    params.order.bill.value = bill;
    params.shippingFee = shippingFee;

    const participantUpdated = params.participants.map((p) => {
      const localDateString = dayjs(p.birthDate.value).format('MM/DD/YYYY');
      return {
        ...p,
        birthDate: localDateString,
      };
    });
    params.participants = participantUpdated;

    const cp = code?.data?.coupon_id ? code : coupon;

    const regParams = {
      event: data?.info,
      category: selectedCategory,
      coupon: {
        id: cp?.data?.coupon_id,
        code: cp?.data?.code,
      },
      selectedAddons,
      ...params,
    };

    // return console.log(regParams);

    setLoadOrderAndGetSnapToken(true);

    try {
      await api.post(process.env.REACT_APP_VIRTUAL_FREE, regParams);

      //console.log('HERE ', result);
      // alert(`Check your offlane races table ${result.data}`);
      alert(`Registration Complete, Next step will be sent via email`);

      window.location = '/';
      setTimeout(() => {
        setLoadOrderAndGetSnapToken(false);
      }, 150);
    } catch (error) {
      setLoadOrderAndGetSnapToken(false);
      alert(JSON.stringify(error.response.data));
    }
  };

  const getRemainingSlotText = (item) => {
    if (!item) return '-';

    const limit = parseInt(item.priceLimit);
    const priceCount =
      parseInt(item.pricePending) + parseInt(item.priceSuccess);
    const resultCount = limit - priceCount;

    if (resultCount > 0) {
      const dividerNumber =
        parseInt(item.adultsLimit) +
        parseInt(item.kidsLimit) +
        parseInt(item.participantLimit);

      return resultCount / dividerNumber;
    } else {
      const pending = parseInt(item.pricePending);
      if (pending > 0) return 'Full';
      return 'Sold Out!';
    }
  };

  const checkSlotLimit = (item) => {
    if (!item) return;

    const limit = parseInt(item.priceLimit);
    const priceCount =
      parseInt(item.pricePending) + parseInt(item.priceSuccess);
    const resultCount = limit - priceCount;

    if (resultCount > 0) {
      return true;
    } else {
      const pending = parseInt(item.pricePending);
      if (pending > 0) alert('Slot Full, please try again later');
      else alert('Ticket Sold Out!');

      return false;
    }
  };

  const joinEvent = () => {
    // const valid = checkSlotLimit(item);

    // if (valid === false) return;

    setIsOpenDialog((prev) => !prev);
  };

  //#endregion

  //#region handle code
  const handleTabChange = (event, newValue) => {
    setTabIdx(newValue);
  };

  const handleOnChange = (event) => {
    const categoryFind = data?.categories?.find(
      (cat) => cat.categoryId.toString() === event.target.value.toString()
    );
    // console.log(categoryFind);
    setSelectedCategory(categoryFind);
  };

  const handleCodeDataChange = (key, item) => {
    const updated = { ...code };

    updated[key] = item;

    setCode(updated);
  };

  const handleJoinEvent = async () => {
    //return console.log('join event ', selectedCategory);
    try {
      if (code.value === '') return alert('Input Code.');
      setIsFetchingCodeStatus(true);

      const { data: couponData } = await api.get(
        `/events/offline/coupon/${data?.info?.eventId}/${code.value}/${selectedCategory?.categoryId}`
      );

      setIsFetchingCodeStatus(false);

      handleCodeDataChange('data', couponData);

      setIsOpenDialog(true);
    } catch (error) {
      setIsFetchingCodeStatus(false);
      alert(error.response.data);
    }
  };

  const handleChoosePayment = async ({ bill, coupon, addons, shippingFee }) => {
    // return console.log(data);

    // if (data?.info?.eventId === 45 && !coupon?.data?.coupon_id)
    //   return alert('You can continue after use coupon');
    const selectedAddons = addons.filter((ad) => ad.selected === true);

    if (parseInt(bill) === 0)
      return register({ bill, coupon, selectedAddons, shippingFee });

    if (loadOrderAndGetSnapToken) return;
    if (snapToken !== '') return;

    setLoadOrderAndGetSnapToken(true);

    const params = { ...dp };
    params.order.bill.value = bill;
    params.order.shippingFee = shippingFee;

    const participantUpdated = params.participants.map((p) => {
      const localDateString = dayjs(p.birthDate.value).format('MM/DD/YYYY');
      return {
        ...p,
        birthDate: localDateString,
      };
    });
    params.participants = participantUpdated;

    // return console.log(
    //   JSON.stringify({
    //     event: data?.info,
    //     category: selectedCategory,
    //     coupon: {
    //       id: coupon?.data?.coupon_id,
    //       code: coupon?.data?.code,
    //     },
    //     ...params,
    //   })
    // );

    // console.log('handle choosepayments');
    try {
      const result = await api.post(process.env.REACT_APP_VIRTUAL_PAY, {
        event: data?.info,
        category: selectedCategory,
        coupon: {
          id: coupon?.data?.coupon_id,
          code: coupon?.data?.code,
        },
        selectedAddons,
        ...params,
      });

      //   console.log('HERE ', result);
      // alert(`Check your offlane races table ${result.data}`);
      setSnapToken(result.data.url);
      // setTimeout(() => {
      //   setLoadOrderAndGetSnapToken(false);
      // }, 200);
    } catch (error) {
      setLoadOrderAndGetSnapToken(false);
      setSnapToken('');
      alert(JSON.stringify(error.response.data));
    }
  };

  const handleGoToSummary = ({ email, participants, addons }) => {
    // console.log(email);
    // return console.log(participants);
    const updated = { ...dp };
    updated.order = {
      email: { value: email.email.value },
      orderType: { value: 'web' },
      bill: { value: 0 },
    };

    updated.participants = participants;
    updated.addons = addons;

    setDp(updated);
    setIsOpenDialog((prev) => !prev);
    setSnapToken('');

    setTimeout(() => {
      setIsOpenSummary((prev) => !prev);
    }, 200);
  };

  //#endregion

  //#region loading and error view
  if (isFetching)
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: { xs: 8, sm: 5 },
        }}
      >
        <CircularProgress size="4rem" />
      </Box>
    );

  if (error)
    return (
      <Box
        display={'flex'}
        flexGrow={1}
        flex={1}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
        sx={{ height: '500px' }}
      >
        <Error sx={{ fontSize: '64px', color: '#afafaf' }} />
        <Typography sx={{ color: '#afafaf' }} variant="h3">
          {error.error.split(':')[1].toUpperCase()}
        </Typography>
      </Box>
    );
  //#endregion

  return (
    <>
      <Grid
        container
        style={classes.containerSpaceAround}
        sx={{
          flexDirection: { xs: 'column', lg: 'row' },
          flexWrap: { xs: 'wrap', sm: 'inherit' },
          mt: { xs: 3, sm: 4 },
        }}
      >
        {/* image */}
        <Grid item sm={12} lg={5} style={classes.bannerContainer}>
          <img
            src={data?.info?.banner}
            alt={data?.info?.name}
            style={
              isMobile
                ? classes.bannerMobile
                : isTab
                ? classes.bannerMedium
                : classes.banner
            }
          />
        </Grid>
        {/* event detail information container */}
        <Grid
          item
          container
          lg={7}
          sx={{
            marginTop: { xs: '0', sm: '2rem', lg: '0' },
            paddingInline: { xs: '2em', sm: '0' },
            paddingBottom: { xs: '' },
          }}
        >
          {/* event information detail */}
          <Grid item xs={12} sm={6}>
            <div
              style={{
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                marginTop: isMobile ? '10px' : '0',
              }}
            >
              {/* event info -- start */}
              <Typography
                variant={!isMobile ? 'h4' : 'h6'}
                fontWeight={'600'}
                component={'div'}
              >
                {data?.info?.name}
              </Typography>
              <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={tabIdx}
                    onChange={handleTabChange}
                    aria-label="basic tabs example"
                  >
                    <Tab label="Details" {...a11lyProps(0)} />
                    <Tab label="Add-Ons" {...a11lyProps(1)} />
                  </Tabs>
                </Box>
                <CustomTabPanel value={tabIdx} index={0}>
                  {/* event info -- end */}
                  <RaceOrRacepackInfo
                    isMobile={isMobile}
                    label={'Sports'}
                    sports={data.info.sports}
                  />
                  {/* racepack info -- start */}
                  <RaceOrRacepackInfo
                    isMobile={isMobile}
                    isSubmit
                    label={'Racepack Collection Info'}
                    start={data?.info?.startDate}
                    end={data?.info?.endDate}
                    isRacepack
                  />
                  {/* description */}
                  <EventInfoFragment
                    isMobile={isMobile}
                    label={'Description'}
                    body={data?.info?.description}
                  />
                </CustomTabPanel>
                <CustomTabPanel value={tabIdx} index={1}>
                  <RacepacksFragments racepacks={data?.addOns} />
                </CustomTabPanel>
              </Box>
            </div>
          </Grid>

          {/* choose category */}
          <Grid item xs={12} sm={6}>
            <div
              style={{
                display: 'flex',
                marginLeft: isMobile ? '0' : '1rem',
                marginTop: isMobile ? '10px' : '0',
              }}
            >
              <Box
                display={'flex'}
                justifyContent={'flex-start'}
                marginBottom={'10px'}
                flexDirection={'column'}
                borderRadius={'14px'}
                padding={'10px 16px'}
                flex={1}
                sx={{
                  border: 3,
                  borderColor: 'grey.200',
                }}
              >
                {dayjs().unix() <
                  dayjs(data?.info?.startRegistrationDate).unix() && (
                  <CountdownTimer
                    openRegDate={data?.info?.startRegistrationDate}
                  />
                )}

                {dayjs().unix() >
                  dayjs(data?.info?.endRegistrationDate).unix() && (
                  <Typography variant="h4" color={'GrayText'}>
                    Registration Already Closed.
                  </Typography>
                )}

                {dayjs().unix() >=
                  dayjs(data?.info?.startRegistrationDate).unix() &&
                dayjs().unix() <=
                  dayjs(data?.info?.endRegistrationDate).unix() ? (
                  <FormControl>
                    <FormLabel id="choose-category-form">
                      Choose Your Category
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="choose-category-form"
                      value={selectedCategory?.categoryId}
                      onChange={handleOnChange}
                    >
                      {data?.categories?.map((category, idx) => (
                        <FormControlLabel
                          key={idx}
                          value={category?.categoryId}
                          control={<Radio />}
                          label={category?.name || category?.categoryName}
                        />
                      ))}
                    </RadioGroup>
                    {selectedCategory && (
                      <>
                        <Box display={'flex'} flexDirection={'column'}>
                          <Divider
                            style={{ marginBottom: '11px', marginTop: '11px' }}
                          />
                          <Box display={'flex'} flexDirection={'row'}>
                            <Box
                              display={'flex'}
                              flexGrow={1}
                              flexDirection={'row'}
                              justifyContent={'space-between'}
                            >
                              <Typography variant="h5" fontWeight={'600'}>
                                Registration Fee
                              </Typography>
                              <Typography variant="h5">
                                {data?.info?.registrationFee === '0'
                                  ? 'FREE'
                                  : `Rp
                                      ${toCurrencyForm(
                                        data?.info?.registrationFee
                                      )}`}
                              </Typography>
                            </Box>
                            {/* <Box
                              display={'flex'}
                              flexGrow={1}
                              flexDirection={'column'}
                            >
                              <Typography variant="body1" fontWeight={'600'}>
                                Price Group
                              </Typography>
                              <Typography variant="body1">
                                {selectedCategory?.priceLabel}
                              </Typography>
                            </Box>
                            {data?.info?.eventId !== 69 && (
                              <Box
                                display={'flex'}
                                flexGrow={1}
                                flexDirection={'column'}
                              >
                                <Typography variant="body1" fontWeight={'600'}>
                                  Slot
                                </Typography>
                                <Typography variant="body1">
                                  {getRemainingSlotText(selectedCategory)}
                                </Typography>
                              </Box>
                            )} */}
                          </Box>

                          <Button
                            variant="contained"
                            style={{ marginTop: '10px' }}
                            onClick={joinEvent}
                          >
                            Join Event!
                          </Button>
                        </Box>
                        {/* {data?.info?.isInternal > 0 && (
                          <Box display={'flex'} flexDirection={'column'}>
                            <Divider style={{ marginBottom: '4px' }} />
                            <Box
                              display={'flex'}
                              flexDirection={'row'}
                              marginBottom={'20px'}
                            >
                              <Box
                                display={'flex'}
                                flexGrow={1}
                                flexDirection={'column'}
                              >
                                <Typography variant="body1" fontWeight={'600'}>
                                  RegistrationFee
                                </Typography>
                                <Typography variant="body1">
                                  {data?.info?.registrationFee === '0'
                                    ? 'FREE'
                                    : `Rp
                                      ${toCurrencyForm(
                                        data?.info?.registrationFee
                                      )}`}
                                </Typography>
                              </Box>
                              <Box
                                display={'flex'}
                                flexGrow={1}
                                flexDirection={'column'}
                              >
                                <Typography variant="body1" fontWeight={'600'}>
                                  Price Group
                                </Typography>
                                <Typography variant="body1">
                                  {selectedCategory?.priceLabel}
                                </Typography>
                              </Box>
                              <Box
                                display={'flex'}
                                flexGrow={1}
                                flexDirection={'column'}
                              >
                                <Typography variant="body1" fontWeight={'600'}>
                                  Slot
                                </Typography>
                                <Typography variant="body1">
                                  {getRemainingSlotText(selectedCategory)}
                                </Typography>
                              </Box>
                            </Box>

                            <FormTextField
                              index={1}
                              i={0}
                              required
                              label={'Code'}
                              errorMessage={code.errorMessage}
                              value={code.value}
                              onChange={(e) =>
                                handleCodeDataChange('value', e.target.value)
                              }
                            />

                            <LoadingButton
                              variant="contained"
                              //   onClick={handleJoinEvent}
                              loading={isFetchingCodeStatus}
                            >
                              Join Event!
                            </LoadingButton>
                          </Box>
                        )} */}
                      </>
                    )}
                  </FormControl>
                ) : null}
              </Box>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <DetailVirtualParticipants
        eventId={data?.info?.eventId}
        addOns={data?.addOns}
        showDialog={isOpenDialog}
        goToSummary={handleGoToSummary}
        closeDialog={() => setIsOpenDialog(false)}
      />
      <VirtualTicketSummary
        showSummary={isOpenSummary}
        onClose={() => setIsOpenSummary((prev) => !prev)}
        event={data?.info}
        participants={dp?.participants}
        category={selectedCategory}
        order={dp?.order}
        addons={dp?.addons}
        onChoosePayment={handleChoosePayment}
        isLoading={loadOrderAndGetSnapToken}
      />
    </>
  );
};

export default VirtualEventInformation;
